export function NotFound() {
  return (
    <div className="flex min-h-screen w-full flex-col ">
      <main className="flex flex-1 justify-center items-center">
        <h1 className="scroll-m-20 text-4xl tracking-tight lg:text-5xl">
          404 | Not Found
        </h1>
      </main>
    </div>
  );
}
